import {SETTINGS_PROPS_TYPES} from '@/const';
import {
  CATEGORIES_FOR_HOMEPAGE,
  CATEGORIES_FOR_HOMEPAGE_CROSS_FILTER,
  GET_ATTRIBUTES_FOR_HOMEPAGE,
  GET_LOCATIONS_FOR_HOMEPAGE,
  GROUPS_FOR_HOMEPAGE,
  GROUPS_FOR_HOMEPAGE_CROSS_FILTER,
  PARTICIPANTS_FOR_HOMEPAGE,
  PARTICIPANTS_FOR_HOMEPAGE_CROSS_FILTER,
} from '@/store/getterTypes';
import {
  getBuilderKey,
  getBuilderTitle,
  PASS_DISPLAY_TYPES,
} from '@/ui_builder/componentsMapper';
const getLinkItems = (size, rotated) => {
  const ratio = 16 / 9;
  let sizes;

  switch (size) {
    case 'small':
      sizes = {
        minWidth: 90,
        maxWidth: 120,
        minMobleCount: 4.2,
      };
      break;
    case 'medium':
      sizes = {
        minWidth: 150,
        maxWidth: 200,
        minMobleCount: 3.2,
      };
      break;
    case 'large':
      sizes = {
        minWidth: 250,
        maxWidth: 320,
        minMobleCount: 1.2,
      };
      break;
    default:
      sizes = {
        minWidth: 150,
        maxWidth: 200,
        minMobleCount: 1.2,
      };
  }
  if (rotated) {
    return {
      ...sizes,
      minWidth: sizes.maxWidth * ratio,
      maxWidth: sizes.minWidth * ratio,
    };
  }
  return sizes;
};
const getLinkCarouselProps = (dynamic, builder) => {
  const rotated = builder.view === 'rectangle' && builder.orientation === 'landscape';
  const size = getLinkItems(builder.size, rotated);

  return {
    title: getBuilderTitle(builder),
    key: getBuilderKey(builder),
    showIfSelected: {
      type: SETTINGS_PROPS_TYPES.STATIC,
      value: !dynamic.crossFilter,
    },
    linkStyleClass: {
      type: SETTINGS_PROPS_TYPES.STATIC,
      value: builder.view, // [square, rectangle, circle]
    },
    minWidth: {
      type: SETTINGS_PROPS_TYPES.STATIC,
      value: size.minWidth,
    },
    orientation: {
      type: SETTINGS_PROPS_TYPES.STATIC,
      value: builder.orientation, // [portrait, landscape]
    },
    backgroundNeed: {
      type: SETTINGS_PROPS_TYPES.STATIC,
      value: builder.background,
    },
    titlePosition: {
      type: SETTINGS_PROPS_TYPES.STATIC,
      value: builder.title || '', // [under_card, on_card, null]
    },
    maxWidth: {
      type: SETTINGS_PROPS_TYPES.STATIC,
      value: size.maxWidth,
    },
    minMobleCount: {
      type: SETTINGS_PROPS_TYPES.STATIC,
      value: size.minMobleCount,
    },
    size: {
      type: SETTINGS_PROPS_TYPES.STATIC,
      value: builder.size,
    },
  };
};

export const HOME_TYPES_NAMES = {
  SLIDES: 'slides',
  EVENTS: 'events',
  EVENT_CATEGORIES: 'event_categories',
  PARTICIPANT_GROUPS: 'participant_groups',
  PARTICIPANTS: 'participants',
  LOCATIONS: 'locations',
  ATTRIBUTES: 'attributes',
  MEDIA_RAILS: 'media_rails',
  PASSES: 'passes',
  MEDIA_RAIL_SLOT: 'media_rails_slot',
};

export default {
  [HOME_TYPES_NAMES.SLIDES]: {
    component: {
      pathKey: 'Slider',
      props: (dynamic, builder) => ({
        key: getBuilderKey(builder),
      }),
    },
  },
  [HOME_TYPES_NAMES.EVENTS]: {
    component: {
      pathKey: 'eventsCarousel',
      props: (dynamic, builder) => ({
        key: getBuilderKey(builder),
        title: getBuilderTitle(builder),
        categories: {
          type: SETTINGS_PROPS_TYPES.COMPUTED,
          value: dynamic.categoryId,
        },
        groups: {
          type: SETTINGS_PROPS_TYPES.COMPUTED,
          value: dynamic.groupId,
        },
        participants: {
          type: SETTINGS_PROPS_TYPES.COMPUTED,
          value: dynamic.participantId,
        },
        attributes: {
          type: SETTINGS_PROPS_TYPES.COMPUTED,
          value: dynamic.selectedAttributeId,
        },
        canProcessRequest: {
          type: SETTINGS_PROPS_TYPES.COMPUTED,
          value: dynamic.allowProcessingEventRequest,
        },
        statusList: {
          type: SETTINGS_PROPS_TYPES.STATIC,
          value: [builder.value],
        },
      }),
    },
  },
  [HOME_TYPES_NAMES.EVENT_CATEGORIES]: {
    component: {
      pathKey: 'LinkCarousel',
      props: (dynamic, builder) => ({
        ...getLinkCarouselProps(dynamic, builder),
        getterName: {
          type: SETTINGS_PROPS_TYPES.STATIC,
          value: dynamic.crossFilter ?
            CATEGORIES_FOR_HOMEPAGE_CROSS_FILTER :
            CATEGORIES_FOR_HOMEPAGE,
        },
      }),
    },
  },
  [HOME_TYPES_NAMES.PARTICIPANT_GROUPS]: {
    component: {
      pathKey: 'LinkCarousel',
      props: (dynamic, builder) => ({
        ...getLinkCarouselProps(dynamic, builder),
        getterName: {
          type: SETTINGS_PROPS_TYPES.STATIC,
          value: dynamic.crossFilter ? GROUPS_FOR_HOMEPAGE_CROSS_FILTER : GROUPS_FOR_HOMEPAGE,
        },
      }),
    },
  },
  [HOME_TYPES_NAMES.PARTICIPANTS]: {
    component: {
      pathKey: 'LinkCarousel',
      props: (dynamic, builder) => ({
        ...getLinkCarouselProps(dynamic, builder),
        getterName: {
          type: SETTINGS_PROPS_TYPES.STATIC,
          value: dynamic.crossFilter ?
            PARTICIPANTS_FOR_HOMEPAGE_CROSS_FILTER :
            PARTICIPANTS_FOR_HOMEPAGE,
        },
      }),
    },
  },
  [HOME_TYPES_NAMES.LOCATIONS]: {
    component: {
      pathKey: 'LinkCarousel',
      props: (dynamic, builder) => ({
        ...getLinkCarouselProps(dynamic, builder),
        getterName: {
          type: SETTINGS_PROPS_TYPES.STATIC,
          value: GET_LOCATIONS_FOR_HOMEPAGE,
        },
      }),
    },
  },
  [HOME_TYPES_NAMES.ATTRIBUTES]: {
    component: {
      pathKey: 'LinkCarousel',
      props: (dynamic, builder) => ({
        ...getLinkCarouselProps(dynamic, builder),
        getterName: {
          type: SETTINGS_PROPS_TYPES.STATIC,
          value: GET_ATTRIBUTES_FOR_HOMEPAGE,
        },
        getterValue: {
          type: SETTINGS_PROPS_TYPES.STATIC,
          value: builder.value,
        },
      }),
    },
  },
  [HOME_TYPES_NAMES.MEDIA_RAILS]: {
    component: {
      pathKey: 'vodRail',
      props: (dynamic, builder) => ({
        key: getBuilderKey(builder),
        title: getBuilderTitle(builder),
        id: {
          type: SETTINGS_PROPS_TYPES.STATIC,
          value: builder.value,
        },
      }),
    },
  },
  [HOME_TYPES_NAMES.MEDIA_RAIL_SLOT]: {
    component: {
      pathKey: 'vodRail',
      props: (dynamic, builder) => ({
        key: getBuilderKey(builder),
        title: getBuilderTitle(builder),
        slotKey: {
          type: SETTINGS_PROPS_TYPES.STATIC,
          value: builder.key,
        },
      }),
    },
  },
  [HOME_TYPES_NAMES.PASSES]: {
    component: {
      pathKey: 'PassesForHome',
      props: (dynamic, builder) => {
        const isTable = builder.view?.toLowerCase() === PASS_DISPLAY_TYPES.TABLE;
        const isCard = builder.view?.toLowerCase() === PASS_DISPLAY_TYPES.CARD;
        const isTabs = builder.view?.toLowerCase() === PASS_DISPLAY_TYPES.TABS;

        return {
          key: getBuilderKey(builder),
          title: getBuilderTitle(builder),
          tableComponentPath: {
            type: SETTINGS_PROPS_TYPES.STATIC,
            value: isTable ? 'passTable' : '',
          },
          cardComponentPath: { // [passCard, passCardV2, passCardFromTable]
            type: SETTINGS_PROPS_TYPES.STATIC,
            value: 'passCard',
          },
          passMergeField: {
            type: SETTINGS_PROPS_TYPES.STATIC,
            value: (isCard || (isTable && builder.merge)) ? builder.group_by : '',
          },
          tabsFieldName: {
            type: SETTINGS_PROPS_TYPES.STATIC,
            value: (isTabs || (isTable && !builder.merge)) ? builder.group_by : '',
          },
        };
      },
    },
  },
};
